// Podroze /App.tsx
import React, { useState, useEffect, useRef } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import CookieConsent from "react-cookie-consent";
import 'flag-icons/css/flag-icons.min.css';
import Logotyp2 from './NOVApodroze.svg';
import './carousel.css';
import PolitykaPrywatnosci from './PolitykaPrywatnosci';


// Import obrazów 
import podroze1 from './podroze1.jpg';
import podroze2 from './podroze2.jpg';
import podroze3 from './podroze3.jpg';
import podroze4 from './podroze4.jpg';
import podroze5 from './podroze5.jpg';
import podroze6 from './podroze6.jpg';
import podroze7 from './podroze7.jpg';
import podroze8 from './podroze8.jpg';
import wlochy from './wlochy.jpg';
import grecja from './grecja.jpg';
import hiszpania from './hiszpania.jpg';
import skandynawia from './skandynawia.jpg';
import zespol from './zespol.jpg';
import LOT from './LO.jpg';
import Lufthansa from './LH.jpg';
import Expedia from './EX.jpg';
import RESTEL from './RE.jpg';
import KLM from './KL.jpg';
import RYANAIR from './FR.jpg';
import WIZZAIR from './W6.jpg';
import Booking from './BO.jpg';


// Dodaj placeholderowy obraz tła dla sekcji hero
import heroBackground from './background.jpg';


const App: React.FC = () => {
  return (
    // ← BRAK Router tutaj, ponieważ jest już w index.tsx
    <Routes>
      <Route path="/" element={<Podroze />} />
      <Route path="/polityka-prywatnosci" element={<PolitykaPrywatnosci />} />
      <Route path="*" element={<Podroze />} />
    </Routes>
  );
};

const sendEmail = async (formData: { name: string; email: string; message: string }) => {
  try {
    console.log('Wysyłanie danych:', formData);
    
    // ZMIANA: Użyj względnej ścieżki zamiast pełnego URL
    const response = await fetch('/send-email.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    console.log('Status odpowiedzi:', response.status);
    const result = await response.json();
    console.log('Odpowiedź serwera:', result);

    if (!response.ok) {
      throw new Error(result.error || 'Błąd podczas wysyłania wiadomości');
    }

    return true;
  } catch (error) {
    console.error('Błąd wysyłania email:', error);
    return false;
  }
};


const Podroze: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState<'PL' | 'DE' | 'EN'>('PL');
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isVisible, setIsVisible] = useState({
    hero: false,
    services: false,
    about: false,
    destinations: false,
    contact: false
  });
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [currentLightboxImage, setCurrentLightboxImage] = useState('');
  const [lightboxImages, setLightboxImages] = useState<string[]>([]);

  const observerRefs = {
    hero: useRef(null),
    services: useRef(null),
    about: useRef(null),
    destinations: useRef(null),
    contact: useRef(null)
  };

  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [currentGalleryIndex, setCurrentGalleryIndex] = useState(0);

  const galleryImages = [
  wlochy, grecja, hiszpania, skandynawia,
  podroze1, podroze2, podroze3, podroze4, 
  podroze5, podroze6, podroze7, podroze8
];

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1500);
    
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    };
    
    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const section = entry.target.getAttribute('data-section');
          if (section) {
            setIsVisible(prev => ({ ...prev, [section]: true }));
          }
        }
      });
    };
    
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    
    Object.keys(observerRefs).forEach(key => {
      if (observerRefs[key as keyof typeof observerRefs].current) {
        observer.observe(observerRefs[key as keyof typeof observerRefs].current!);
      }
    });
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };
  }, []);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const toggleLangDropdown = () => setIsLangDropdownOpen(!isLangDropdownOpen);
  const selectLanguage = (lang: 'PL' | 'DE' | 'EN') => {
    setCurrentLanguage(lang);
    setIsLangDropdownOpen(false);
  };

  const openLightbox = (image: string, images: string[], index: number = 0) => {
    setCurrentLightboxImage(images[index]);
    setLightboxImages(images);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
    setCurrentLightboxImage('');
    setLightboxImages([]);
  };

  const navigateLightbox = (direction: 'next' | 'prev') => {
    const currentIndex = lightboxImages.indexOf(currentLightboxImage);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % lightboxImages.length;
    } else {
      newIndex = (currentIndex - 1 + lightboxImages.length) % lightboxImages.length;
    }
    
    setCurrentLightboxImage(lightboxImages[newIndex]);
  };

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    if (targetId === '#') return;
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      window.scrollTo({
        top: targetElement.getBoundingClientRect().top + window.pageYOffset - 80,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  const form = e.target as HTMLFormElement;
  const formData = {
    name: (form.elements.namedItem('name') as HTMLInputElement).value,
    email: (form.elements.namedItem('email') as HTMLInputElement).value,
    message: (form.elements.namedItem('message') as HTMLTextAreaElement).value,
  };

  const success = await sendEmail(formData);
  
  setIsSubmitting(false);
  
  if (success) {
    setIsFormSubmitted(true);
    form.reset();
    setTimeout(() => setIsFormSubmitted(false), 5000);
  } else {
    alert('Wystąpił błąd podczas wysyłania wiadomości. Spróbuj ponownie.');
  }
};

  const translations = {
  PL: {
    nav: { home: "Strona Główna", services: "Usługi", destinations: "Destynacje", about: "O Nas", contact: "Kontakt", quote: "Zapytanie" },
    hero: { title: "NOVA Podróże", subtitle: "Profesjonalna organizacja podróży i wycieczek", servicesBtn: "Nasze usługi", contactBtn: "Skontaktuj się" },
    services: { title: "Nasze Usługi", description: "Oferujemy kompleksową organizację podróży, wycieczek i wakacji.",
      flights: { title: "Bilety lotnicze", description: "Rezerwacja i wykup biletów na najlepszych warunkach.", items: ["Rezerwacja biletów linii regularnych","Wykup biletów tanich linii","Wyszukiwanie najlepszych połączeń","Pomoc przy zmianie rezerwacji"] },
      hotels: { title: "Rezerwacje hotelowe", description: "Znajdowanie idealnych noclegów dostosowanych do Twoich potrzeb.", items: ["Hotele i apartamenty","Rezerwacje online","Najlepsze lokalizacje","Opłacenie wszystkich podatków"] },
      insurance: { title: "Ubezpieczenia", description: "Kompleksowe ubezpieczenia podróżne dla Twojego bezpieczeństwa.", items: ["Ubezpieczenia turystyczne","Ubezpieczenia zdrowotne","OC w podróży","Ubezpieczenie bagażu"] }
    },
    about: { title: "O Nas", description1: "NOVA Podróże to agencja turystyczna z wieloletnim doświadczeniem w organizacji podróży.", description2: "Nasz zespół składa się z pasjonatów podróży, którzy dbają o każdy detal Twojej wymarzonej wycieczki.", quality: "Gwarancja jakości", qualityDesc: "Sprawdzeni partnerzy", speed: "Szybka realizacja", speedDesc: "Efektywne planowanie", experience: "Doświadczenie", experienceDesc: "Ponad 7 lat na rynku" },
    aboutExtended: {
      passion: "Podróże to nasza pasja i sposób na życie.",
      teamDescription: "Jesteśmy zespołem doświadczonych doradców turystycznych, którzy łączą wiedzę, profesjonalizm i autentyczną miłość do podróżowania. Dzięki temu każda wycieczka przygotowana przez nasze biuro jest nie tylko dobrze zorganizowana, ale też pełna wyjątkowych doświadczeń, które zostają w pamięci na lata.",
      whyChooseUs: "Dlaczego warto wybrać właśnie nas?",
      individualApproach: "Indywidualne podejście",
      individualDesc: "Uważnie słuchamy Twoich potrzeb i dopasowujemy ofertę",
      verifiedPartners: "Sprawdzeni partnerzy", 
      verifiedDesc: "Współpracujemy wyłącznie z zaufanymi hotelami i przewoźnikami",
      fullService: "Kompleksowa obsługa",
      fullServiceDesc: "Jesteśmy z Tobą od pierwszego kontaktu do powrotu z podróży",
      transparency: "Transparentność",
      transparencyDesc: "Żadnych ukrytych kosztów ani niespodzianek",
      experiencePassion: "Doświadczenie i pasja",
      experienceDesc: "Każdy projekt to dla nas podróż marzeń",
      support247: "Wsparcie 24/7",
      supportDesc: "Dostępność przez cały czas trwania wyjazdu",
      ourMission: "Nasza misja",
      missionText: "Chcemy, aby każdy mógł podróżować w taki sposób, w jaki zawsze marzył – bez stresu, w pełnym komforcie i z poczuciem, że za wszystkim stoi zespół, na który można liczyć.",
      inviteContact: "Zapraszamy do kontaktu",
      inviteText: "Marzysz o weekendzie w europejskiej stolicy, wakacjach w egzotycznym kurorcie, a może o wyprawie życia na drugi koniec świata?",
      createDreamTrip: "Stwórzmy razem Twoją podróż marzeń",
      satisfiedClients: "Zadowolonych klientów",
      yearsExperience: "Lata doświadczenia",
      countries: "Krajów oferty"
    },
    destinations: { title: "Popularne Destynacje", description: "Odkryj nasze najpopularniejsze kierunki podróży i znajdź inspirację na kolejną przygodę.", items: [{title:"Włochy",description:"Malownicze wybrzeża, zabytkowe miasta i wyśmienita kuchnia"},{"title":"Grecja","description":"Słoneczne wyspy, antyczne zabytki i błękitne morze"},{"title":"Hiszpania","description":"Tętniące życiem miasta, piękne plaże i bogata kultura"},{"title":"Skandynawia","description":"Niesamowite fiordy, zorze polarne i nowoczesne metropolie"}] },
    contact: { title: "Kontakt", description: "Skontaktuj się z nami, aby zaplanować wymarzoną podróż.", infoTitle:"Kontakt", phone:"Telefon", email:"Email", address:"Adres", formTitle:"Wyślij zapytanie", name:"Imię i nazwisko", message:"Wiadomość", send:"Wyślij zapytanie" },
    footer: { description: "Profesjonalna organizacja podróży i wycieczek.", services: "Usługi", company: "Firma", hours: "Godziny otwarcia", rights: "Wszelkie prawa zastrzeżone. Strona autorstwa Michał Szczepański" },
    partners: {
      title: "Nasi Partnerzy",
      description: "Współpracujemy z wiodącymi markami w branży turystycznej, aby zapewnić Ci najlepsze warunki podróży",
      benefits: "Korzyści z partnerskiej współpracy",
      exclusiveDeals: "Exclusive Deals",
      exclusiveDesc: "Dostęp do specjalnych ofert i promocji",
      prioritySupport: "Priority Support", 
      priorityDesc: "Priorytetowa obsługa i wsparcie",
      bestRates: "Best Rates",
      bestRatesDesc: "Gwarancja najlepszych cen",
      partnershipBenefits: "Dzięki partnerskim relacjom z wiodącymi firmami w branży turystycznej, możemy zaoferować Ci:",
      bestPrices: "Najlepsze ceny",
      fastBookings: "Szybkie rezerwacje",
      fullSecurity: "Pełne bezpieczeństwo",
      flexibleTerms: "Elastyczne warunki"
    }
  },
  DE: {
    nav: { home: "Startseite", services: "Dienstleistungen", destinations: "Reiseziele", about: "Über uns", contact: "Kontakt", quote: "Anfrage" },
    hero: { title: "NOVA Reisen", subtitle: "Professionelle Reiseorganisation und Exkursionen", servicesBtn: "Unsere Dienstleistungen", contactBtn: "Kontakt aufnehmen" },
    services: { title: "Unsere Dienstleistungen", description: "Wir bieten umfassende Organisation von Reisen, Exkursionen und Urlauben.",
      flights: { title: "Flugtickets", description: "Reservierung und Kauf von Tickets zu den besten Konditionen.", items: ["Buchung von Linienflugtickets","Kauf von Billigflugtickets","Suche nach den besten Verbindungen","Hilfe bei Buchungsänderungen"] },
      hotels: { title: "Hotelreservierungen", description: "Finden der idealen Unterkünfte nach Ihren Bedürfnissen.", items: ["Hotels und Apartments","Online-Reservierungen","Beste Lagen","Reservierungsbestätigungen"] },
      insurance: { title: "Versicherungen", description: "Umfassende Reiseversicherungen für Ihre Sicherheit.", items: ["Reiseversicherungen","Krankenversicherungen","Haftpflicht auf Reisen","Luggage insurance"] }
    },
    about: { title: "Über uns", description1: "NOVA Reisen ist ein Reisebüro mit langjähriger Erfahrung in der Reiseorganisation.", description2: "Unser Team besteht aus Reiseenthusiasten, die sich um jedes Detail Ihrer Traumreise kümmern.", quality:"Qualitätsgarantie", qualityDesc:"Geprüfte Partner", speed:"Schnelle Umsetzung", speedDesc:"Effiziente Planung", experience: "Erfahrung", experienceDesc: "Über 10 Jahre am Markt" },
    aboutExtended: {
      passion: "Reisen ist unsere Leidenschaft und Lebensweise.",
      teamDescription: "Wir sind ein Team erfahrener Reiseberater, die Wissen, Professionalität und eine echte Reiseliebe verbinden. Dadurch ist jede von unserem Büro organisierte Reise nicht nur gut organisiert, sondern auch voller einzigartiger Erlebnisse, die noch lange in Erinnerung bleiben.",
      whyChooseUs: "Warum sollten Sie uns wählen?",
      individualApproach: "Individueller Ansatz",
      individualDesc: "Wir hören aufmerksam auf Ihre Bedürfnisse und passen das Angebot an",
      verifiedPartners: "Geprüfte Partner",
      verifiedDesc: "Wir arbeiten ausschließlich mit vertrauenswürdigen Hotels und Transportunternehmen",
      fullService: "Komplettservice",
      fullServiceDesc: "Wir sind für Sie da vom ersten Kontakt bis zur Rückkehr von der Reise",
      transparency: "Transparenz",
      transparencyDesc: "Keine versteckten Kosten oder Überraschungen",
      experiencePassion: "Erfahrung und Leidenschaft",
      experienceDesc: "Jedes Projekt ist für uns eine Traumreise",
      support247: "Support 24/7",
      supportDesc: "Verfügbarkeit während der gesamten Reise",
      ourMission: "Unsere Mission",
      missionText: "Wir möchten, dass jeder so reisen kann, wie er es sich immer erträumt hat – stressfrei, in vollem Komfort und mit dem Gefühl, dass hinter allem ein Team steht, auf das man zählen kann.",
      inviteContact: "Kontaktieren Sie uns",
      inviteText: "Träumen Sie von einem Wochenende in einer europäischen Hauptstadt, einem Urlaub in einem exotischen Resort oder vielleicht der Reise Ihres Lebens ans andere Ende der Welt?",
      createDreamTrip: "Lassen Sie uns gemeinsam Ihre Traumreise gestalten",
      satisfiedClients: "Zufriedene Kunden",
      yearsExperience: "Jahre Erfahrung",
      countries: "Länder im Angebot"
    },
    destinations: { title: "Beliebte Reiseziele", description:"Entdecken Sie unsere beliebtesten Reiserouten und finden Sie Inspiration für Ihr nächstes Abenteuer.", items:[{title:"Italien",description:"Malerische Küsten, historische Städte und ausgezeichnete Küche"},{title:"Griechenland",description:"Sonnenverwöhnte Inseln, antike Denkmäler und blaues Meer"},{title:"Spanien",description:"Lebendige Städte, schöne Strände und reiche Kultur"},{title:"Skandinavien",description:"Unglaubliche Fjorde, Polarlichter und moderne Metropolen"}] },
    contact: { title:"Kontakt", description:"Kontaktieren Sie uns, um Ihre Traumreise zu planen.", infoTitle:"Kontakt", phone:"Telefon", email:"E-Mail", address:"Adresse", formTitle:"Anfrage senden", name:"Vor- und Nachname", message:"Nachricht", send:"Anfrage senden" },
    footer: { description:"Professionelle Organisation von Reisen und Exkursionen.", services:"Dienstleistungen", company:"Firma", hours: "Öffnungszeiten", rights:"Alle Rechte vorbehalten. Seite erstellt von Michal Szczepanski" },
    partners: {
      title: "Unsere Partner",
      description: "Wir arbeiten mit führenden Marken in der Tourismusbranche zusammen, um Ihnen die besten Reisebedingungen zu bieten",
      benefits: "Vorteile der Partnerschaft",
      exclusiveDeals: "Exklusive Angebote",
      exclusiveDesc: "Zugang zu Sonderangeboten und Promotionen",
      prioritySupport: "Prioritätsunterstützung",
      priorityDesc: "Priorisierte Betreuung und Unterstützung",
      bestRates: "Beste Preise",
      bestRatesDesc: "Garantie für die besten Preise",
      partnershipBenefits: "Dank unserer Partnerschaftsbeziehungen mit führenden Unternehmen in der Tourismusbranche können wir Ihnen Folgendes bieten:",
      bestPrices: "Beste Preise",
      fastBookings: "Schnelle Buchungen",
      fullSecurity: "Volle Sicherheit",
      flexibleTerms: "Flexible Bedingungen"
    }
  },
  EN: {
    nav: { home: "Home", services: "Services", destinations: "Destinations", about: "About", contact: "Contact", quote: "Inquiry" },
    hero: { title: "NOVA Travel", subtitle: "Professional travel organization and excursions", servicesBtn: "Our Services", contactBtn: "Contact Us" },
    services: { title: "Our Services", description: "We provide comprehensive organization of travels, excursions and vacations.",
      flights: { title: "Flight Tickets", description: "Reservation and purchase of tickets on the best terms.", items: ["Regular airline ticket booking","Low-cost airline tickets","Finding the best connections","Help with booking changes"] },
      hotels: { title: "Hotel Reservations", description: "Finding ideal accommodations tailored to your needs.", items: ["Hotels and apartments","Online reservations","Best locations","Reservation confirmations"] },
      insurance: { title: "Insurance", description: "Comprehensive travel insurance for your safety.", items: ["Travel insurance","Health insurance","Liability during travel","Luggage insurance"] }
    },
    about: { title:"About", description1:"NOVA Travel is a travel agency with many years of experience in travel organization.", description2:"Our team consists of travel enthusiasts who care about every detail of your dream trip.", quality:"Quality guarantee", qualityDesc:"Verified partners", speed:"Fast execution", speedDesc:"Efficient planning", experience: "Experience", experienceDesc: "Over 10 years in the market" },
    aboutExtended: {
      passion: "Travel is our passion and way of life.",
      teamDescription: "We are a team of experienced travel advisors who combine knowledge, professionalism and a genuine love for travel. This ensures that every trip organized by our office is not only well-organized but also full of unique experiences that remain in memory for years.",
      whyChooseUs: "Why choose us?",
      individualApproach: "Individual approach",
      individualDesc: "We listen carefully to your needs and tailor the offer",
      verifiedPartners: "Verified partners",
      verifiedDesc: "We work exclusively with trusted hotels and carriers",
      fullService: "Full service",
      fullServiceDesc: "We are with you from the first contact until return from the trip",
      transparency: "Transparency",
      transparencyDesc: "No hidden costs or surprises",
      experiencePassion: "Experience and passion",
      experienceDesc: "Every project is a dream journey for us",
      support247: "Support 24/7",
      supportDesc: "Availability throughout the entire trip",
      ourMission: "Our mission",
      missionText: "We want everyone to be able to travel the way they've always dreamed of – stress-free, in full comfort, and with the feeling that there's a team behind everything that can be counted on.",
      inviteContact: "Contact us",
      inviteText: "Dreaming of a weekend in a European capital, a vacation in an exotic resort, or perhaps the trip of a lifetime to the other side of the world?",
      createDreamTrip: "Let's create your dream trip together",
      satisfiedClients: "Satisfied clients",
      yearsExperience: "Years of experience",
      countries: "Countries offered"
    },
    destinations: { title:"Popular Destinations", description:"Discover our most popular travel routes and find inspiration for your next adventure.", items:[{title:"Italy",description:"Picturesque coasts, historic cities and excellent cuisine"},{title:"Greece",description:"Sun-drenched islands, ancient monuments and blue sea"},{title:"Spain",description:"Vibrant cities, beautiful beaches and rich culture"},{title:"Scandinavia",description:"Incredible fjords, northern lights and modern metropolises"}] },
    contact: { title:"Contact", description:"Get in touch with us to plan your dream trip.", infoTitle:"Contact", phone:"Phone", email:"Email", address:"Address", formTitle:"Send inquiry", name:"Name", message:"Message", send:"Send Inquiry" },
    footer: { description:"Professional organization of travels and excursions.", services:"Services", company:"Company", hours: "Opening Hours", rights:"All rights reserved. Site by Michal Szczepanski" },
    partners: {
      title: "Our Partners",
      description: "We cooperate with leading brands in the tourism industry to provide you with the best travel conditions",
      benefits: "Partnership benefits",
      exclusiveDeals: "Exclusive Deals",
      exclusiveDesc: "Access to special offers and promotions",
      prioritySupport: "Priority Support",
      priorityDesc: "Priority service and support",
      bestRates: "Best Rates",
      bestRatesDesc: "Guarantee of the best prices",
      partnershipBenefits: "Thanks to our partnership relations with leading companies in the tourism industry, we can offer you:",
      bestPrices: "Best prices",
      fastBookings: "Fast bookings",
      fullSecurity: "Full security",
      flexibleTerms: "Flexible terms"
    }
  }
};

  const t = translations[currentLanguage];

  const ListItem: React.FC<{ item: string }> = ({ item }) => (
    <li className="flex items-center opacity-80 group-hover:opacity-100 transition-opacity duration-300">
      <i className="fas fa-check text-blue-400 mr-2 transform group-hover:scale-110 transition-transform duration-300"></i>
      <span className="text-gray-700">{item}</span>
    </li>
  );

  const ServiceCard: React.FC<{ icon: string; title: string; description: string; items: string[] }> = ({ icon, title, description, items }) => (
    <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 border border-gray-200 hover:-translate-y-2 group cursor-pointer">
      <div className="text-4xl mb-4 transform group-hover:scale-110 transition-transform duration-300">{icon}</div>
      <h3 className="text-xl font-bold mb-2 text-gray-900 group-hover:text-blue-400 transition-colors duration-300">{title}</h3>
      <p className="text-gray-600 mb-4">{description}</p>
      <ul className="space-y-2">{items.map((item,i)=><ListItem key={i} item={item} />)}</ul>
    </div>
  );

  const DestinationCard: React.FC<{ image:string; title:string; description:string }> = ({image,title,description}) => (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-all duration-500 border border-gray-200 group cursor-pointer"
      onClick={() => openLightbox(image, galleryImages, galleryImages.indexOf(image))}>
      <div className="h-48 flex items-center justify-center text-white relative overflow-hidden">
        <img 
          src={image} 
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-blue-600 opacity-30 group-hover:opacity-10 transition-opacity duration-500"></div>
        <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity duration-500"></div>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-bold mb-2 text-gray-900 group-hover:text-blue-400 transition-colors duration-300">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      {isLoading && (
        <div className="fixed inset-0 bg-white z-50 flex items-center justify-center">
          <div className="flex flex-col items-center">
            <div className="relative w-24 h-24">
              <div className="w-full h-full border-4 border-blue-400 border-t-transparent rounded-full animate-spin"></div>
              <img 
                src={Logotyp2} 
                alt="NOVA Podróże" 
                className="absolute inset-0 m-auto w-16 h-16"
              />
            </div>
            <p className="mt-4 text-gray-600">Ładowanie...</p>
          </div>
        </div>
      )}

      <nav className={`fixed w-full z-40 transition-all duration-300 ${isScrolled ? 'bg-gray-900/95 backdrop-blur-md shadow-md py-2' : 'bg-transparent py-4'}`}>
  <div className="container mx-auto px-4 flex justify-between items-center">
    <div className="flex items-center">
      <img src={Logotyp2} alt="NOVA Podróże" className="h-10 md:h-12 filter brightness-0 invert" />
      {/* Napis z błyszczącym wave strike-through */}
      <div className="ml-4 relative">
        <span className="text-white font-bold text-lg md:text-xl lg:text-2xl font-sans relative z-10">
          Zawsze do celu
        </span>
        <div className="absolute top-1/2 left-0 w-full h-0.5 transform -translate-y-1/2">
          <div className="w-full h-full bg-gradient-to-r from-transparent via-blue-400/80 to-transparent opacity-80 animate-wave-shine"></div>
        </div>
      </div>
    </div>

    <div className="hidden md:flex space-x-8">
      {Object.entries(t.nav).filter(([key]) => key !== 'quote').map(([key, value]) => (
        <a key={key} href={`#${key}`} onClick={(e) => handleSmoothScroll(e, `#${key}`)} 
          className="text-white hover:text-blue-400 font-medium transition-colors duration-300">
          {value}
        </a>
      ))}
    </div>
    
    <div className="flex items-center space-x-4">
      <div className="relative">
        <button onClick={toggleLangDropdown} className="flex items-center space-x-1 text-white hover:text-blue-400 transition-colors duration-300">
          <span className={`fi fi-${currentLanguage === 'PL' ? 'pl' : currentLanguage === 'DE' ? 'de' : 'gb'} rounded`}></span>
          <span className="hidden md:inline">{currentLanguage}</span>
          <i className={`fas ${isLangDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'} text-xs`}></i>
        </button>
        
        {isLangDropdownOpen && (
          <div className="absolute right-0 mt-2 w-32 bg-black/20 backdrop-blur-md rounded-lg shadow-lg py-2 z-50">
            {(['PL', 'DE', 'EN'] as const).filter(lang => lang !== currentLanguage).map(lang => (
              <button key={lang} onClick={() => selectLanguage(lang)} className="flex items-center space-x-2 w-full px-4 py-2 text-left hover:bg-white/10 transition-colors duration-200 text-white">
                <span className={`fi fi-${lang === 'PL' ? 'pl' : lang === 'DE' ? 'de' : 'gb'} rounded`}></span>
                <span>{lang}</span>
              </button>
            ))}
          </div>
        )}
      </div>
      
      <a href="#contact" onClick={(e) => handleSmoothScroll(e, '#contact')} className="hidden md:inline-block bg-blue-400 hover:bg-blue-500 text-white px-6 py-2 rounded-full font-medium transition-colors duration-300 transform hover:-translate-y-0.5">
        {t.nav.quote}
      </a>
      
      <button onClick={toggleMobileMenu} className="md:hidden text-gray-700">
        <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
      </button>
    </div>
  </div>
  
  {isMobileMenuOpen && (
    <div className="md:hidden bg-black/20 backdrop-blur-md py-4 px-4">
      <div className="flex flex-col space-y-3">
        {Object.entries(t.nav).filter(([key]) => key !== 'quote').map(([key, value]) => (
          <a key={key} href={`#${key}`} onClick={(e) => handleSmoothScroll(e, `#${key}`)} 
            className="text-white hover:text-blue-400 py-2 px-4 font-medium transition-colors duration-300">
            {value}
          </a>
        ))}
        <a href="#contact" onClick={(e) => handleSmoothScroll(e, '#contact')} className="bg-blue-400 hover:bg-blue-500 text-white px-6 py-2 rounded-full font-medium transition-colors duration-300 text-center">
          {t.nav.quote}
        </a>
      </div>
    </div>
  )}
</nav>

<style>
{`
@keyframes infinite-scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
.animate-infinite-scroll {
  display: flex;
  width: max-content;
  animation: infinite-scroll 40s linear infinite;
}
.animate-infinite-scroll:hover {
  animation-play-state: paused;
}

/* Nowe style dla błyszczącego wave strike-through */
@keyframes waveShine {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    opacity: 0;
  }
}
.animate-wave-shine {
  animation: waveShine 2s ease-in-out infinite;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(96, 165, 250, 0.8),
    rgba(96, 165, 250, 0.9),
    rgba(96, 165, 250, 0.8),
    transparent
  );
  background-size: 200% 100%;
}
`}
</style>

      <div className="absolute top-16 md:top-20 w-full h-8 bg-gradient-to-b from-black/30 to-transparent z-30 pointer-events-none"></div>

      {/* Sekcja HERO z nowym tłem i logo */}
      <section id="home" ref={observerRefs.hero} data-section="hero" className="relative min-h-screen flex items-center justify-center pt-20">
        <div className="absolute inset-0 z-0">
          <img 
            src={heroBackground} 
            alt="Tło podróżnicze" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-sm"></div>
        </div>
        
        <div className="container mx-auto px-4 z-10 text-center">
          <div className={`transform transition-all duration-1000 ${isVisible.hero ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <img 
              src={Logotyp2} 
              alt="NOVA Podróże" 
              className="mx-auto mb-8 h-24 md:h-32 lg:h-40 w-auto filter brightness-0 invert"
            />
            <p className="text-xl md:text-2xl text-white mb-8 max-w-2xl mx-auto leading-relaxed">
              {t.hero.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="#services" onClick={(e) => handleSmoothScroll(e, '#services')} className="bg-blue-400 hover:bg-blue-500 text-white px-8 py-3 rounded-full font-medium transition-colors duration-300 transform hover:-translate-y-0.5">
                {t.hero.servicesBtn}
              </a>
              <a href="#contact" onClick={(e) => handleSmoothScroll(e, '#contact')} className="bg-white hover:bg-gray-100 text-blue-400 px-8 py-3 rounded-full font-medium transition-colors duration-300 transform hover:-translate-y-0.5">
                {t.hero.contactBtn}
              </a>
            </div>
          </div>
        </div>
        
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <a href="#services" onClick={(e) => handleSmoothScroll(e, '#services')} className="text-white text-2xl">
            <i className="fas fa-chevron-down"></i>
          </a>
        </div>
      </section>

      <section id="services" ref={observerRefs.services} data-section="services" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className={`text-center mb-16 transform transition-all duration-1000 ${isVisible.services ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">{t.services.title}</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">{t.services.description}</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className={`transform transition-all duration-1000 delay-150 ${isVisible.services ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
              <ServiceCard 
                icon="✈️" 
                title={t.services.flights.title} 
                description={t.services.flights.description}
                items={t.services.flights.items}
              />
            </div>
            
            <div className={`transform transition-all duration-1000 delay-300 ${isVisible.services ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
              <ServiceCard 
                icon="🏨" 
                title={t.services.hotels.title} 
                description={t.services.hotels.description}
                items={t.services.hotels.items}
              />
            </div>
            
            <div className={`transform transition-all duration-1000 delay-450 ${isVisible.services ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
              <ServiceCard 
                icon="🛡️" 
                title={t.services.insurance.title} 
                description={t.services.insurance.description}
                items={t.services.insurance.items}
              />
            </div>
          </div>
        </div>
      </section>

<section id="about" ref={observerRefs.about} data-section="about" className="py-20 bg-gradient-to-br from-white to-blue-50/30 relative overflow-hidden">
  {/* Dekoracyjne elementy tła */}
  <div className="absolute top-0 right-0 w-72 h-72 bg-blue-200/10 rounded-full blur-3xl transform translate-x-36 -translate-y-36"></div>
  <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-300/10 rounded-full blur-3xl transform -translate-x-48 translate-y-48"></div>
  
  <div className="container mx-auto px-4 relative z-10">
    {/* Nagłówek sekcji z animacją */}
    <div className={`text-center mb-16 transform transition-all duration-1000 ${isVisible.about ? 'translate-y-0 opacity-100' : '-translate-y-8 opacity-0'}`}>
      <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-400/10 rounded-2xl mb-6">
        <span className="text-3xl text-blue-500">✈️</span>
      </div>
      <h2 className="text-5xl font-bold text-gray-900 mb-4 bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent">
        {t.about.title}
      </h2>
      <div className="w-24 h-1 bg-gradient-to-r from-blue-400 to-blue-600 mx-auto rounded-full"></div>
    </div>

    <div className="grid lg:grid-cols-12 gap-12 items-start">
      {/* Lewa kolumna - tekst */}
      <div className="lg:col-span-7 space-y-8">
        {/* Wstęp */}
        <div className={`transform transition-all duration-1000 delay-150 ${isVisible.about ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
          <p className="text-xl text-gray-700 leading-relaxed font-light">
            <span className="text-2xl text-blue-500 mr-2">✈️</span>
            <strong className="font-semibold text-gray-900">{t.aboutExtended.passion}</strong> {t.about.description1}
          </p>
        </div>

        {/* Drugi akapit */}
        <div className={`transform transition-all duration-1000 delay-300 ${isVisible.about ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
          <p className="text-lg text-gray-600 leading-relaxed">
            {t.aboutExtended.teamDescription}
          </p>
        </div>

        {/* Dlaczego warto nas wybrać */}
        <div className={`transform transition-all duration-1000 delay-450 ${isVisible.about ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
          <h3 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white mr-3 text-sm">✓</span>
            {t.aboutExtended.whyChooseUs}
          </h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            {[
              { icon: "👂", title: t.aboutExtended.individualApproach, desc: t.aboutExtended.individualDesc },
              { icon: "🤝", title: t.aboutExtended.verifiedPartners, desc: t.aboutExtended.verifiedDesc },
              { icon: "🛡️", title: t.aboutExtended.fullService, desc: t.aboutExtended.fullServiceDesc },
              { icon: "🔍", title: t.aboutExtended.transparency, desc: t.aboutExtended.transparencyDesc },
              { icon: "❤️", title: t.aboutExtended.experiencePassion, desc: t.aboutExtended.experienceDesc },
              { icon: "⏰", title: t.aboutExtended.support247, desc: t.aboutExtended.supportDesc }
            ].map((item, index) => (
              <div key={index} className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-500 hover:-translate-y-1 border border-gray-100">
                <div className="text-2xl mb-3">{item.icon}</div>
                <h4 className="font-semibold text-gray-900 mb-2">{item.title}</h4>
                <p className="text-sm text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Misja i zaproszenie */}
        <div className={`transform transition-all duration-1000 delay-600 ${isVisible.about ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">🌟 {t.aboutExtended.ourMission}</h3>
            <p className="mb-6 opacity-95">
              {t.aboutExtended.missionText}
            </p>
            
            <h3 className="text-2xl font-bold mb-4">💫 {t.aboutExtended.inviteContact}</h3>
            <p className="mb-6 opacity-95">
              {t.aboutExtended.inviteText}
            </p>
            
            <a 
              href="#contact" 
              onClick={(e) => handleSmoothScroll(e, '#contact')}
              className="inline-block bg-white text-blue-600 px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:-translate-y-1 hover:shadow-2xl"
            >
              <i className="fas fa-calendar-check mr-3"></i>
              {t.aboutExtended.createDreamTrip}
            </a>
          </div>
        </div>
      </div>

      {/* Prawa kolumna - zdjęcia */}
      <div className="lg:col-span-5">
        <div className="sticky top-24 space-y-6">
          {/* Główne zdjęcie */}
          <div className={`transform transition-all duration-1000 delay-300 ${isVisible.about ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
            <div className="relative group cursor-pointer">
              <img 
                src={zespol} 
                alt="Zespół NOVA Podróże" 
                className="w-full h-96 object-cover rounded-3xl shadow-2xl transform group-hover:scale-105 transition-transform duration-700"
                onClick={() => openLightbox(zespol, [zespol])}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute bottom-6 left-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <span className="text-sm font-medium">Nasz zespół ekspertów</span>
              </div>
            </div>
          </div>

          {/* Grid mniejszych zdjęć */}
          <div className="grid grid-cols-2 gap-6">
            {[podroze2, podroze3, podroze4, podroze5].map((image, index) => (
              <div 
                key={index}
                className={`transform transition-all duration-1000 delay-${450 + index * 150} ${
                  isVisible.about ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
                }`}
              >
                <div className="relative group cursor-pointer">
                  <img 
                    src={image} 
                    alt={`Projekt podróży ${index + 1}`}
                    className="w-full h-48 object-cover rounded-2xl shadow-lg transform group-hover:scale-110 transition-transform duration-500"
                    onClick={() => openLightbox(image, [image])}
                  />
                  <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                      <i className="fas fa-search-plus text-white text-lg"></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Statystyki */}
          <div className={`bg-white/90 backdrop-blur-md rounded-2xl p-6 shadow-lg transform transition-all duration-1000 delay-900 ${
            isVisible.about ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}>
            <div className="grid grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-1">4500+</div>
                <div className="text-sm text-gray-600">{t.aboutExtended.satisfiedClients}</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-1">4+</div>
                <div className="text-sm text-gray-600">{t.aboutExtended.yearsExperience}</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-1">90+</div>
                <div className="text-sm text-gray-600">{t.aboutExtended.countries}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

{/* Sekcja Partnerzy */}
<section className="py-20 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
  {/* Dekoracyjne elementy tła */}
  <div className="absolute top-0 left-0 w-64 h-64 bg-blue-100/20 rounded-full blur-3xl transform -translate-x-32 -translate-y-32"></div>
  <div className="absolute bottom-0 right-0 w-80 h-80 bg-blue-200/20 rounded-full blur-3xl transform translate-x-40 translate-y-40"></div>

  <div className="container mx-auto px-4 relative z-10">
    {/* Nagłówek sekcji */}
    <div className="text-center mb-16">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-500/10 rounded-2xl mb-6">
        <i className="fas fa-handshake text-2xl text-blue-600"></i>
      </div>
      <h2 className="text-4xl font-bold text-gray-900 mb-4">
        {t.partners.title}
      </h2>
      <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-6">
        {t.partners.description}
      </p>
      <div className="w-20 h-1 bg-gradient-to-r from-blue-400 to-blue-600 mx-auto rounded-full"></div>
    </div>

    {/* Karuzela partnerów */}
    <div className="relative w-full max-w-6xl mx-auto h-64 mb-16 overflow-hidden">
      <div className="absolute inset-0 flex items-center">
        <div className="flex items-center space-x-8 animate-infinite-scroll">
          {[
            { name: "LOT Polish Airlines", logo: LOT, description: "Narodowy przewoźnik Polski" },
            { name: "Deutsche Lufthansa AG", logo: Lufthansa, description: "Niemiecki lider lotnictwa" },
            { name: "Expedia", logo: Expedia, description: "Globalna platforma rezerwacyjna" },
            { name: "RESTEL", logo: RESTEL, description: "System rezerwacji hoteli" },
            { name: "KLM Royal Dutch Airlines", logo: KLM, description: "Holenderskie linie lotnicze" },
            { name: "RYANAIR", logo: RYANAIR, description: "Europejski lider tanich lotów" },
            { name: "WIZZAIR", logo: WIZZAIR, description: "Węgierskie tanie linie lotnicze" },
            { name: "Booking", logo: Booking, description: "Światowy lider rezerwacji" },
          ].map((partner, index) => (
            <div 
              key={index}
              className="flex-shrink-0 w-48 transition-all duration-500"
            >
              <div className="group relative bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100">
                {/* Logo partnera */}
                <div className="flex items-center justify-center h-20 mb-4">
                  <div className="relative w-full h-full flex items-center justify-center">
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-gray-50 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    <img 
                      src={partner.logo} 
                      alt={partner.name}
                      className="h-12 object-contain max-w-full transform group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                </div>

                {/* Nazwa i opis */}
                <div className="text-center">
                  <h3 className="font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors duration-300">
                    {partner.name}
                  </h3>
                  <p className="text-sm text-gray-600 opacity-80 group-hover:opacity-100 transition-opacity duration-300">
                    {partner.description}
                  </p>
                </div>

                {/* Hover effect overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                {/* Corner accent */}
                <div className="absolute top-0 right-0 w-3 h-3 bg-gradient-to-br from-blue-500 to-blue-600 rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
            </div>
          ))}
          {/* Druga kopia tej samej listy dla płynnego loopa */}
          {[
            { name: "LOT Polish Airlines", logo: LOT, description: "Narodowy przewoźnik Polski" },
            { name: "Deutsche Lufthansa AG", logo: Lufthansa, description: "Niemiecki lider lotnictwa" },
            { name: "Expedia", logo: Expedia, description: "Globalna platforma rezerwacyjna" },
            { name: "RESTEL", logo: RESTEL, description: "System rezerwacji hoteli" },
            { name: "KLM Royal Dutch Airlines", logo: KLM, description: "Holenderskie linie lotnicze" },
            { name: "RYANAIR", logo: RYANAIR, description: "Europejski lider tanich lotów" },
            { name: "WIZZAIR", logo: WIZZAIR, description: "Węgierskie tanie linie lotnicze" },
            { name: "Booking", logo: Booking, description: "Światowy lider rezerwacji" },
          ].map((partner, index) => (
            <div 
              key={`copy-${index}`}
              className="flex-shrink-0 w-48 transition-all duration-500"
            >
              <div className="group relative bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100">
                {/* Logo partnera */}
                <div className="flex items-center justify-center h-20 mb-4">
                  <div className="relative w-full h-full flex items-center justify-center">
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-gray-50 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    <img 
                      src={partner.logo} 
                      alt={partner.name}
                      className="h-12 object-contain max-w-full transform group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                </div>

                {/* Nazwa i opis */}
                <div className="text-center">
                  <h3 className="font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors duration-300">
                    {partner.name}
                  </h3>
                  <p className="text-sm text-gray-600 opacity-80 group-hover:opacity-100 transition-opacity duration-300">
                    {partner.description}
                  </p>
                </div>

                {/* Hover effect overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                {/* Corner accent */}
                <div className="absolute top-0 right-0 w-3 h-3 bg-gradient-to-br from-blue-500 to-blue-600 rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Gradienty na krawędziach */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-gray-50 to-transparent z-40"></div>
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-50 to-transparent z-40"></div>
    </div>

    {/* Dodatkowe informacje */}
    <div className="mt-16 text-center">
      <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">💎 {t.partners.benefits}</h3>
        <div className="grid md:grid-cols-3 gap-6 text-left">
          <div className="flex items-start">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
              <i className="fas fa-percent text-blue-600 text-sm"></i>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-1">{t.partners.exclusiveDeals}</h4>
              <p className="text-sm text-gray-600">{t.partners.exclusiveDesc}</p>
            </div>
          </div>
          <div className="flex items-start">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
              <i className="fas fa-star text-blue-600 text-sm"></i>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-1">{t.partners.prioritySupport}</h4>
              <p className="text-sm text-gray-600">{t.partners.priorityDesc}</p>
            </div>
          </div>
          <div className="flex items-start">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
              <i className="fas fa-shield-alt text-blue-600 text-sm"></i>
            </div>
            <div>
              <h4 className="font-semibold text-gray-900 mb-1">{t.partners.bestRates}</h4>
              <p className="text-sm text-gray-600">{t.partners.bestRatesDesc}</p>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-gray-600 mb-4">
            {t.partners.partnershipBenefits}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium">⭐ {t.partners.bestPrices}</span>
            <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium">⚡ {t.partners.fastBookings}</span>
            <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium">🛡️ {t.partners.fullSecurity}</span>
            <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium">🎯 {t.partners.flexibleTerms}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<style>
{`
@keyframes infinite-scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
.animate-infinite-scroll {
  display: flex;
  width: max-content;
  animation: infinite-scroll 40s linear infinite;
}
.animate-infinite-scroll:hover {
  animation-play-state: paused;
}
`}
</style>



      <section id="contact" ref={observerRefs.contact} data-section="contact" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-12">
            <div className="lg:w-1/2">
              <div className={`transform transition-all duration-1000 ${isVisible.contact ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">{t.contact.title}</h2>
                <p className="text-lg text-gray-600 mb-8">{t.contact.description}</p>
                
                <div className="space-y-6">
                  <h3 className="text-xl font-bold text-gray-900">{t.contact.infoTitle}</h3>
                  
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                      <i className="fas fa-phone text-blue-400"></i>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">{t.contact.phone}</p>
                      <p className="text-gray-600">+48 727 144 431</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                      <i className="fas fa-envelope text-blue-400"></i>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">{t.contact.email}</p>
                      <p className="text-gray-600">podroze@novahls.pl</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                      <i className="fas fa-map-marker-alt text-blue-400"></i>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900">{t.contact.address}</p>
                      <p className="text-gray-600">ul. Stanisławowska 47<br></br>54-611 Wrocław, Polska</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="lg:w-1/2">
              <div className={`bg-gray-50 rounded-xl p-8 transform transition-all duration-1000 delay-300 ${isVisible.contact ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">{t.contact.formTitle}</h3>
                
                {isFormSubmitted ? (
                  <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-6">
                    <p>Dziękujemy za wiadomość! Skontaktujemy się z Tobą wkrótce.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">{t.contact.name}</label>
                      <input type="text" id="name" name="name" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-300" />
                    </div>
                    
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                      <input type="email" id="email" name="email" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-300" />
                    </div>
                    
                    <div>
                      <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">{t.contact.message}</label>
                      <textarea id="message" name="message" rows={5} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-300"></textarea>
                    </div>
                    
                    <button type="submit" disabled={isSubmitting} className="w-full bg-blue-400 hover:bg-blue-500 text-white py-3 px-6 rounded-lg font-medium transition-colors duration-300 transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed">
                      {isSubmitting ? (
                        <span className="flex items-center justify-center">
                          <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></span>
                          Wysyłanie...
                        </span>
                      ) : (
                        t.contact.send
                      )}
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

            <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-5 gap-8">
            <div>
              <img src={Logotyp2} alt="NOVA Podróże" className="h-10 mb-4 filter brightness-0 invert" />
              <p className="text-gray-400">{t.footer.description}</p>
            </div>
            
            <div>
              <h4 className="font-bold text-lg mb-4">{t.footer.services}</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#services" onClick={(e) => handleSmoothScroll(e, '#services')} className="hover:text-blue-400 transition-colors duration-300">{t.services.flights.title}</a></li>
                <li><a href="#services" onClick={(e) => handleSmoothScroll(e, '#services')} className="hover:text-blue-400 transition-colors duration-300">{t.services.hotels.title}</a></li>
                <li><a href="#services" onClick={(e) => handleSmoothScroll(e, '#services')} className="hover:text-blue-400 transition-colors duration-300">{t.services.insurance.title}</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-bold text-lg mb-4">{t.footer.company}</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#about" onClick={(e) => handleSmoothScroll(e, '#about')} className="hover:text-blue-400 transition-colors duration-300">{t.nav.about}</a></li>
                <li><a href="#destinations" onClick={(e) => handleSmoothScroll(e, '#destinations')} className="hover:text-blue-400 transition-colors duration-300">{t.nav.destinations}</a></li>
                <li><a href="#contact" onClick={(e) => handleSmoothScroll(e, '#contact')} className="hover:text-blue-400 transition-colors duration-300">{t.nav.contact}</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-bold text-lg mb-4">{t.footer.hours}</h4>
              <p className="text-gray-400 mb-2">Pon-Pt: 9:00-17:00</p>
              <p className="text-gray-400">Sob-Nd: Zamknięte</p>
            </div>
            
            <div>
              <h4 className="font-bold text-lg mb-4">Dane firmy</h4>
              <ul className="space-y-2 text-gray-400">
                <li>NIP: 8943267784</li>
                <li>REGON: 54263627300000</li>
                <li>KRS: 0001191908</li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 NOVA Podróże - Zawsze do celu. {t.footer.rights}</p>
          </div>
        </div>
      </footer>

      <CookieConsent
        location="bottom"
        buttonText="Akceptuj"
        cookieName="cookieConsent"
        style={{ background: "#2B373B" }}
        buttonStyle={{ background: "#60A5FA", color: "#fff", fontSize: "13px", borderRadius: "4px" }}
        expires={150}
      >
        Ta strona używa plików cookies w celu poprawnego działania.{" "}
        <span style={{ fontSize: "13px" }}>
          <a href="#/polityka-prywatnosci" className="text-blue-400 hover:underline">
            Dowiedz się więcej
          </a>
        </span>
      </CookieConsent>

      {isLightboxOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
          <button onClick={closeLightbox} className="absolute top-4 right-4 text-white text-3xl hover:text-blue-400 transition-colors duration-300">
            <i className="fas fa-times"></i>
          </button>
          
          <button onClick={() => navigateLightbox('prev')} className="absolute left-4 text-white text-2xl hover:text-blue-400 transition-colors duration-300">
            <i className="fas fa-chevron-left"></i>
          </button>
          
          <button onClick={() => navigateLightbox('next')} className="absolute right-4 text-white text-2xl hover:text-blue-400 transition-colors duration-300">
            <i className="fas fa-chevron-right"></i>
          </button>
          
          <img 
            src={currentLightboxImage} 
            alt="Lightbox" 
            className="max-w-full max-h-full object-contain"
          />
        </div>
      )}
    </div>
  );
};

export default App;